// Shopping cart bundle entry point

import { application } from '../controllers/application.js'
import CartController from '../controllers/cart_controller.js'

import './cart.js'
import './checkout-success.js'

// Register cart controller for bundles that include shop
if (application) {
  application.register("cart", CartController)
}
